<template>
	<div class="blog-image" :class="{ 'blog-image-lg-auto': lgAuto }" :style="{ '--blog-image-aspect': aspect }">
		<div class="blog-image-skeleton" :class="{ 'blog-image-skeleton-hidden': isLoaded }" aria-hidden="true"></div>
		<img
			class="blog-image-img"
			:class="{ 'blog-image-img-visible': isLoaded }"
			:src="resolvedSource"
			:alt="alt"
			:width="width"
			:height="height"
			:loading="priority ? 'eager' : 'lazy'"
			:fetchpriority="priority ? 'high' : 'auto'"
			decoding="async"
			@load="isLoaded = true"
			@error="handleError"
		/>
	</div>
</template>

<script setup>
import { computed, ref } from "vue";

const props = defineProps({
	src: {
		type: String,
		required: true,
	},
	alt: {
		type: String,
		default: "",
	},
	aspect: {
		type: String,
		default: "16 / 10",
	},
	priority: {
		type: Boolean,
		default: false,
	},
	lgAuto: {
		type: Boolean,
		default: false,
	},
	fallbackSrc: {
		type: String,
		default: "",
	},
	width: {
		type: [Number, String],
		default: undefined,
	},
	height: {
		type: [Number, String],
		default: undefined,
	},
});

const isLoaded = ref(false);
const hasErrored = ref(false);

const resolvedSource = computed(() => (hasErrored.value && props.fallbackSrc ? props.fallbackSrc : props.src));

function handleError() {
	if (props.fallbackSrc && !hasErrored.value) {
		hasErrored.value = true;
	}
}
</script>

<style scoped>
.blog-image {
	position: relative;
	overflow: hidden;
	background-color: #f1f5f9;
	aspect-ratio: var(--blog-image-aspect, 16 / 10);
}

.blog-image-skeleton {
	position: absolute;
	inset: 0;
	background-color: #f1f5f9;
	opacity: 1;
	-webkit-animation: blog-image-pulse 1.6s ease-in-out infinite;
	animation: blog-image-pulse 1.6s ease-in-out infinite;
	transition: opacity 0.3s ease;
}

.blog-image-skeleton-hidden {
	opacity: 0;
	-webkit-animation: none;
	animation: none;
}

.blog-image-img {
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	opacity: 0;
	-webkit-transition: opacity 0.5s ease, -webkit-transform 0.5s ease;
	transition: opacity 0.5s ease, transform 0.5s ease;
}

.blog-image-img-visible {
	opacity: 1;
}

@media (min-width: 1024px) {
	.blog-image-lg-auto {
		aspect-ratio: auto;
		min-width: 0;
		height: 100%;
	}
}

@-webkit-keyframes blog-image-pulse {
	0%, 100% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
}

@keyframes blog-image-pulse {
	0%, 100% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
}
</style>